import React from "react"
import { SelectMenu } from "../forms"
import { Field } from "redux-form"
import {Errors} from "../../api/util";
import { connect } from "react-redux"

let InternationalCustomerSelectMenu = props => {

    return <Field name="customer" options={[
        {value: "company", label: "Company", type: "international"},
        {value: "agent", label: "IATA certified agent", type: "international"},
    ]} title="Are you registering as a..." component={SelectMenu} onChange={(e,n,p)=>{ props.dispatch(Errors.clear())}}/>
};

InternationalCustomerSelectMenu = connect()(InternationalCustomerSelectMenu)

export {
    InternationalCustomerSelectMenu,
}
